module.exports = __webpack_public_path__ + "static/DY3-e253831b135e6af4641dbd04850e1952.jpg";